import { sendESputnikTrackingEventRequest } from '../../utils/api/marketingApi';

const trackProfileEvent = (profile) =>
  sendESputnikTrackingEventRequest({
    event_type: 'web funnel login success',
    email: profile.email,
    event_params: [
      {
        name: 'newsletter_sub',
        value: profile.user_settings.newsletters_enabled ? '1' : '0',
      },
      {
        name: 'name',
        value: profile.full_name,
      },
      {
        name: 'account_type',
        value: profile.type,
      },
      {
        name: 'subscription_type',
        value: profile.subscription.sku,
      },
      {
        name: 'sub_form',
        value: 'web funnel login success',
      },
    ],
  });

export { trackProfileEvent };
